export const users = [
  {
    id: '1',
    name: 'Roman Hyrych',
    role: 'Team lead',
    img: 'https://avatars.githubusercontent.com/u/88936471?v=4',
    ginHabLink: 'https://github.com/romanlancer/',
    FB_Link: 'https://www.facebook.com/roman.girich',
    LN_Link:
      'https://www.linkedin.com/in/%D1%80%D0%BE%D0%BC%D0%B0%D0%BD-%D0%B3%D0%B8%D1%80%D0%B8%D1%87-1511bb226/',
    discription:
      'Hello, my friends. I am a beginning FrontEnd developer.I am very excited at learning new things and technologies attached with FrontEnd. Already have some projects in my Portfolio on github.',
  },
  {
    id: '2',
    name: 'Anna Nychyk',
    role: 'Scrum-master',
    img: 'https://avatars.githubusercontent.com/u/88631065?v=4',
    ginHabLink: 'https://github.com/AnnaNychyk',
    FB_Link: 'https://www.facebook.com/profile.php?id=100014572051160',
    LN_Link: 'https://www.linkedin.com/in/anna-nychyk-529061238/',
    discription:
      'Great teamwork. All the people in the team are friendly and open. Helped each other at all stages of work. The team you want to work with.',
  },
  {
    id: '3',
    name: 'Lubov Danchenko',
    role: 'Developer',
    img: 'https://avatars.githubusercontent.com/u/22094005?v=4',
    ginHabLink: 'https://github.com/LDanchenko',
    FB_Link: 'https://www.facebook.com/profile.php?id=100013830070077',
    LN_Link: 'https://www.linkedin.com/in/lubov-danchenko',
    discription:
      'I am very thankful to our friendly team for good and interesting cooperation, and the GoIT company for the opportunity to improve my knowledge in such a project.',
  },
  {
    id: '4',
    name: 'Evgeniy Ignatenko',
    role: 'Developer',
    img: 'https://avatars.githubusercontent.com/u/75755667?v=4',
    ginHabLink: 'https://github.com/eijjeka',
    FB_Link: 'https://www.facebook.com/',
    LN_Link: 'https://www.linkedin.com/in/jekaignat/',
    discription:
      'A very good project for interesting people who want to see everything you want about the film quickly enough',
  },
  {
    id: '5',
    name: 'Viktoriia Mykhalova',
    role: 'Developer',
    img: 'https://avatars.githubusercontent.com/u/88782163?v=4',
    ginHabLink: 'https://github.com/MViktoriia',
    FB_Link: 'https://www.facebook.com/viktoriya.petrachkova',
    LN_Link: 'https://www.linkedin.com/in/viktoriia-mykhalova-758b37237',
    discription:
      'I am very happy to be a part of this project and our team. We are just beginners in the frontend, but we are working hard to help the client achieve his business goals by providing a really cool product.',
  },
  {
    id: '6',
    name: 'Aleksandr Serebro',
    role: 'Developer',
    img: 'https://avatars.githubusercontent.com/u/88261876?v=4',
    ginHabLink: 'https://github.com/AlexSerebro',
    FB_Link: 'https://www.facebook.com/',
    LN_Link: 'https://www.linkedin.com/',
    discription: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
  },
  {
    id: '7',
    name: 'Oleksandr Nikolaienko',
    role: 'Tech lead',
    img: 'https://avatars.githubusercontent.com/u/41318656?v=4',
    ginHabLink: 'https://github.com/aleksander-nikolaenko',
    FB_Link: 'https://www.facebook.com/',
    LN_Link: 'https://www.linkedin.com/in/aleksander-nikolaienko-426b20229/',
    discription:
      'I am a beginner Full Stack developer. I have completed courses in markup and javascript. I continue to study frameworks, such as react.js and node.js.',
  },
  {
    id: '8',
    name: 'Serhii Sakhno',
    role: 'Developer',
    img: 'https://avatars.githubusercontent.com/u/89796587?v=4',
    ginHabLink: 'https://github.com/SerhiiSakhno1994',
    FB_Link: 'https://www.facebook.com/sergeysakhno1',
    LN_Link: 'https://www.linkedin.com/in/serhii-sakhno-25934b229/',
    discription: 'Hi to all. I am a GoIT student who worked on the project in a super team.',
  },
  {
    id: '9',
    name: 'Aleksandr Kashirin',
    role: 'Developer',
    img: 'https://avatars.githubusercontent.com/u/88508533?v=4',
    ginHabLink: 'https://github.com/Saniokkk',
    FB_Link: 'https://www.facebook.com/profile.php?id=100002548663025',
    LN_Link: 'https://www.linkedin.com/in/kashirin-aleksandr-244b49237/',
    discription: 'Well, we did another great project. Now we are much closer to our goal. Thank you for my team and GoIT for their knowledge and experience.',
  },
];

export const usersUA = [
  {
    id: '1',
    name: 'Гирич Роман',
    role: 'Лідер команди',
    img: 'https://avatars.githubusercontent.com/u/88936471?v=4',
    ginHabLink: 'https://github.com/romanlancer/',
    FB_Link: 'https://www.facebook.com/roman.girich',
    LN_Link:
      'https://www.linkedin.com/in/%D1%80%D0%BE%D0%BC%D0%B0%D0%BD-%D0%B3%D0%B8%D1%80%D0%B8%D1%87-1511bb226/',
    discription:
      'Шановні відвідувачі, вітаю Вас на нашому сайті кінофільмів, бажаю приємного перегляду та гарного настрою.',
  },
  {
    id: '2',
    name: 'Анна Ничик',
    role: 'Scrum-мастер',
    img: 'https://avatars.githubusercontent.com/u/88631065?v=4',
    ginHabLink: 'https://github.com/AnnaNychyk',
    FB_Link: 'https://www.facebook.com/profile.php?id=100014572051160',
    LN_Link: 'https://www.linkedin.com/in/anna-nychyk-529061238/',
    discription:
      'Чудова командна робота. Усі люди в команді доброзичливі та відкриті. Допомогали один одному на всіх етапах роботи. Команда з якою хочеться працювати.',
  },
  {
    id: '3',
    name: 'Любов Данченко',
    role: 'Розробник',
    img: 'https://avatars.githubusercontent.com/u/22094005?v=4',
    ginHabLink: 'https://github.com/LDanchenko',
    FB_Link: 'https://www.facebook.com/profile.php?id=100013830070077',
    LN_Link: 'https://www.linkedin.com/in/lubov-danchenko',
    discription:
      'Дякую нашій дружній команді за плідну і цікаву співпрацю, а також проекту GoIT за можливість прокачати свої знання в такому  проекті.',
  },
  {
    id: '4',
    name: 'Євген Ігнатенко',
    role: 'Розробник',
    img: 'https://avatars.githubusercontent.com/u/75755667?v=4',
    ginHabLink: 'https://github.com/eijjeka',
    FB_Link: 'https://www.facebook.com/',
    LN_Link: 'https://www.linkedin.com/in/jekaignat/',
    discription:
      'Дуже приємний проект для цікавих людей, які хочуть переглянути доволі швидко про фільм все, що заманеться',
  },
  {
    id: '5',
    name: 'Вікторія Михальова',
    role: 'Розробник',
    img: 'https://avatars.githubusercontent.com/u/88782163?v=4',
    ginHabLink: 'https://github.com/MViktoriia',
    FB_Link: 'https://www.facebook.com/viktoriya.petrachkova',
    LN_Link: 'https://www.linkedin.com/in/viktoriia-mykhalova-758b37237',
    discription:
      'Я дуже рада бути частиною цього проекту та нашої команди. Ми лише початківці у фронтенді, але ми завзято робимо все можливе, щоб допомогти клієнту досягти його бізнес-цілей, надаючи дійсно крутий продукт.',
  },
  {
    id: '6',
    name: 'Олександр Серебро',
    role: 'Розробник',
    img: 'https://avatars.githubusercontent.com/u/88261876?v=4',
    ginHabLink: 'https://github.com/AlexSerebro',
    FB_Link: 'https://www.facebook.com/',
    LN_Link: 'https://www.linkedin.com/',
    discription: 'Дуже приємно працювати в такій команді!!!',
  },
  {
    id: '7',
    name: 'Олександр Ніколаєнко',
    role: 'Розробник',
    img: 'https://avatars.githubusercontent.com/u/41318656?v=4',
    ginHabLink: 'https://github.com/aleksander-nikolaenko',
    FB_Link: 'https://www.facebook.com/',
    LN_Link: 'https://www.linkedin.com/in/aleksander-nikolaienko-426b20229/',
    discription:
      'Я починаючий Full Stack розробник. Я закінчив курси з html та javascript. Продовжую вивчати фреймворки, такі як react.js та node.js.',
  },
  {
    id: '8',
    name: 'Сергій Сахно',
    role: 'Розробник',
    img: 'https://avatars.githubusercontent.com/u/89796587?v=4',
    ginHabLink: 'https://github.com/SerhiiSakhno1994',
    FB_Link: 'https://www.facebook.com/sergeysakhno1',
    LN_Link: 'https://www.linkedin.com/in/serhii-sakhno-25934b229/',
    discription: 'Привіт всім. Я студент GoIt. Над проектом працював у суперкоманді.',
  },
  {
    id: '9',
    name: 'Олександр Каширін',
    role: 'Розробник',
    img: 'https://avatars.githubusercontent.com/u/88508533?v=4',
    ginHabLink: 'https://github.com/Saniokkk',
    FB_Link: 'https://www.facebook.com/profile.php?id=100002548663025',
    LN_Link: 'https://www.linkedin.com/in/kashirin-aleksandr-244b49237/',
    discription: 'Ну ось зробили ще один чудовий проект. Тепер ми стали набагато ближчі до своєї мети. Дякую моїй команді та компанії GoIT за надані знання та досвід.',
  },
];
